import React, { useMemo, useState } from 'react'
import { Filter, Header } from './component'
import { DataTable, Excel } from 'CommonComponent'
import IntegrationAddModal from './component/IntegrationAddModal/IntegrationAddModal'

const columns = [
  { id: "name", header: "Name", accessor: row => row.name, sortable: true, searchable: true },
  { id: "provider", header: "Provider", accessor: row => row.provider, sortable: true, searchable: true },
  { id: "account_id", header: "Account ID", accessor: row => row.account_id, sortable: true, searchable: true },
  { id: "account_no", header: "Account #", accessor: row => row.account_no, sortable: true, searchable: true },
  { id: "client_id", header: "Client ID", accessor: row => row.client_id, sortable: true, searchable: true },
  { id: "client_secret", header: "Client Secret", accessor: row => row.client_secret, sortable: false, searchable: false },
  { id: "status", header: "Status", accessor: row => row.status, sortable: true, searchable: false },
  { id: "description", header: "Description", accessor: row => row.description, sortable: false, searchable: true },
];

const initialData = [
  {
    name: "Twilio Voice",
    provider: "Twilio",
    account_id: "ACCT-1001",
    account_no: "789456123",
    client_id: "twilio-client-01",
    client_secret: "********",
    status: "Active",
    description: "Twilio voice integration for inbound/outbound calls.",
  },
  {
    name: "Zendesk Chat",
    provider: "Zendesk",
    account_id: "ACCT-2002",
    account_no: "123456789",
    client_id: "zendesk-client-02",
    client_secret: "********",
    status: "Inactive",
    description: "Zendesk chat integration for support.",
  },
  {
    name: "Genesys Email",
    provider: "Genesys",
    account_id: "ACCT-3003",
    account_no: "456789123",
    client_id: "genesys-client-03",
    client_secret: "********",
    status: "Active",
    description: "Genesys email integration for ticketing.",
  },
];

const ACDIntegration = () => {
  const [data, setData] = useState(initialData);
  const [showAddNewModal, setShowAddNewModal] = useState(false);

  // Handler to add new integration
  const handleAddIntegration = (newIntegration) => {
    setData(prev => [...prev, newIntegration]);
    setShowAddNewModal(false);
  };

  return (
    <div className='wrapper-div'>
      <Header onAddNew={() => setShowAddNewModal(true)} />
      <div className="d-flex align-items-center justify-content-end gap-3 px-4 mb-3">
        <Excel />
      </div>
        <Filter />
      <DataTable
        columns={columns}
        data={data}
        serverSide={false}
        showSearch={false}
        className='table-container'
      />
      <IntegrationAddModal
        show={showAddNewModal}
        handleClose={() => setShowAddNewModal(false)}
        onAdd={handleAddIntegration}
      />
    </div>
  )
}

export default ACDIntegration